/** Applies plan-rail cascade updates via executeMoveTask for orderKey + path cascade. */

/**
 * @param {Array<{ id: string, date: unknown, orderKey: string }>} updates
 * @param {object} ctx
 * @param {(id: string, fields: object, userId: string, task?: object) => void | Promise<void>} ctx.moveTask
 * @param {(id: string, fields: object, userId: string) => void | Promise<void>} ctx.updateTask
 * @param {string} ctx.userId
 * @param {Map<string, { date?: unknown, orderKey?: string }>} [ctx.tasksMap]
 */
export const applyCascadeDateOrderUpdates = (
  updates,
  { moveTask, updateTask, userId, tasksMap },
) => {
  if (!userId || updates.length === 0) return;

  updates.forEach(({ id, date, orderKey }) => {
    const task = tasksMap?.get(String(id));
    const orderKeyChanged = !task || task.orderKey !== orderKey;
    const dateChanged = !task || task.date !== date;

    if (orderKeyChanged) {
      const mover = moveTask || updateTask;
      mover(id, { orderKey }, userId, task ?? undefined);
    }
    if (dateChanged && updateTask) {
      updateTask(id, { date }, userId);
    }
  });
};
